module.exports = __webpack_public_path__ + "img/2.0596472f.svg";